export default {
  computed: {
    hasLabel() {
      return !!this.$slots.label
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/common/label-big/label-big.js